import { VFilterBar, type VFilterBarOption } from '@vrzl/ui';

import { indexingStatusLabels } from '../constants';
import { DOCUMENT_FILTERS, type DocumentFilter } from '../helpers/documentFilter';

const OPTIONS: ReadonlyArray<VFilterBarOption<DocumentFilter>> = DOCUMENT_FILTERS.map(
  (value) => ({
    value,
    label: value === 'all' ? 'Alles' : indexingStatusLabels[value],
  }),
);

type DocumentsFilterProps = {
  value: DocumentFilter;
  counts: Record<DocumentFilter, number>;
  onChange: (value: DocumentFilter) => void;
};

/** Filterbalk boven de documentenlijst: alles of één verwerkingsstatus. */
export function DocumentsFilter({ value, counts, onChange }: DocumentsFilterProps) {
  return (
    <VFilterBar
      options={OPTIONS}
      value={value}
      counts={counts}
      onChange={onChange}
      ariaLabel="Filter documenten op status"
    />
  );
}
